export const Colors = {
    light: {
        text: '#11181C',
        background: '#fff',
        card: '#f9f9f9',
        tint: '#0a7ea4',
        icon: '#687076',
        tabIconDefault: '#687076',
        tabIconSelected: '#0a7ea4',
        button: '#1EB980',
        buttonDark: '#045D56',
        orange: '#FF6859',
        link: '#72DEFF'
    },
    dark: {
        text: '#ECEDEE',
        background: '#32333c',
        card: '#37373f',
        tint: '#fff',
        icon: '#9BA1A6',
        tabIconDefault: '#9BA1A6',
        tabIconSelected: '#fff',
        button: '#1EB980',
        buttonDark: '#045D56',
        orange: '#FF6859',
        link: '#72DEFF'
    },
};
